<template>
<v-card>
    <v-card-text>

      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <v-row>


          <v-col
            cols="9"
          >
            <v-row>
              <v-col
                cols="12"
              >
              <ValidationProvider>

              <ValidationProvider
                  rules="required"
                  vid="numero_bolla"
                  :name="$t('fields.numero_bolla').toLowerCase()"
                  v-slot="{ errors }"
              >
                <v-text-field
                  v-model=" form.numero_bolla"
                  :counter="30"
                  :label="$t('fields.numero_bolla')"
                  :error-messages="errors"
                ></v-text-field>

              </ValidationProvider>

              <ValidationProvider
                  rules="required"
                  vid="delimiter"
                  :name="$t('fields.delimiter').toLowerCase()"
                  v-slot="{ errors }"
              >
                <v-text-field
                  v-model=" form.delimiter"
                  :counter="30"
                  :label="$t('fields.delimiter')"
                  :error-messages="errors"
                ></v-text-field>

              </ValidationProvider>
                <vue2Dropzone
                  ref="MyDropzone"
                  class="mt-5"
                  v-on:vdropzone-success="addFile"
                  v-on:vdropzone-sending="sendingEvent"
                  v-on:vdropzone-removed-file="removeFile"
                  :options="dropzoneOptions">
                </vue2Dropzone>
              </ValidationProvider>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="3"
          >
            <p>
              <b>In questa sezione va caricato un file csv con le seguenti colonne separate da {{ form.delimiter }}</b>
            </p>
              <br >
              <p v-if="Object.keys(fields).length">
                <span v-for="(field, index) in fields" :key="field.position">
                  <span v-if="index > 0">{{ form.delimiter }}&nbsp;</span>{{ field.description }}
                </span>
              </p>
          </v-col>
        </v-row>
    </ValidationObserver>

    </v-card-text>

  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';


  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';

  import { warehousesService } from '../../utils/services/warehouses.service';
  import { importerInfoService } from '../../utils/services/importerInfo.service';

  import api from '../../utils/services/api.service';

  export default {
    name: 'WarehouseLoadImport',
    components: {
      vue2Dropzone,
    },
    props: {
      id: [String, Number],
    },
    data() {
      return {
        fields: [],
        form: {
          file: 0,
          delimiter: '|',
          numero_bolla: null,
        },
        loading: false,
        dropzoneOptions: {
          url: `${api.getApiUrl()}/files`,
          thumbnailWidth: 200,
          addRemoveLinks: false,
          headers: { Authorization: localStorage.getItem('auth-token') },
        },
      };
    },

    computed: {

    },

    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),


      sendingEvent(file, XMLHttpRequest, formData) {
        formData.append('name', file.name);
      },

      addFile(file, response) {
        this.form.file = response.file.id;
        warehousesService.importLoad(this.id, this.form)
        .then((response) => {
            this.form.file = 0;
            this.$refs.MyDropzone.removeFile(file);

            let toastType = 'warning';
            if (!response.data.stats.imported) {
              toastType = 'error';
            } else if (response.data.stats.imported === response.data.stats.records) {
              toastType = 'success';
            }

            this.showToast({ type: toastType, message: response.data.message });

            if (Object.keys(response.data.errors).length) {
              let content = '';
              Object.keys(response.data.errors).forEach(line => {
                content += `\n\r Riga: ${ line } ${ response.data.errors[line]}`;
              });

              const link = document.createElement('a');
              const filelog = new Blob([content], { type: 'text/plain' });
              link.href = URL.createObjectURL(filelog);
              link.download = 'log.txt';
              link.click();
              URL.revokeObjectURL(link.href);
            }
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async getFieldsWarehouseLoadImport() {
        importerInfoService.getInfo('warehouse_load')
        .then((response) => {
         this.fields = response.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

    },
    async created() {
      await this.getFieldsWarehouseLoadImport();
    },
  };
</script>

<style>


</style>
